import { useCallback, useMemo, useState } from 'react';
import {
  copyShareLink,
  getShareUrl,
  nativeShare,
  openShareWindow,
  type ShareChannel,
  type SharePayload,
} from '../utils/share';

export function useShare(payload?: SharePayload) {
  const [copied, setCopied] = useState(false);

  const sharePayload = useMemo<SharePayload>(
    () => ({
      url: payload?.url,
      title: payload?.title,
      text: payload?.text ?? payload?.title,
    }),
    [payload?.url, payload?.title, payload?.text],
  );

  const handleShare = useCallback(
    async (channel: ShareChannel) => {
      if (channel === 'copy') {
        const ok = await copyShareLink(sharePayload.url);
        if (ok) {
          setCopied(true);
          window.setTimeout(() => setCopied(false), 2000);
        }
        return;
      }

      if (channel === 'native') {
        const result = await nativeShare(sharePayload);
        if (result === 'unsupported') {
          const ok = await copyShareLink(sharePayload.url);
          if (ok) {
            setCopied(true);
            window.setTimeout(() => setCopied(false), 2000);
          }
        }
        return;
      }

      openShareWindow(getShareUrl(channel, sharePayload));
    },
    [sharePayload],
  );

  return { handleShare, copied };
}
